import { useSelector } from 'react-redux';
import { Failed } from 'shared/components/Failed';
import { Loading } from 'shared/components/Loading';
import { ModalForm } from 'shared/components/ModalForm';
import { Success } from 'shared/components/Success';
import { selectFormStatus } from 'shared/selectors/formStatus';
import { EStatus, TModalForm } from 'shared/types/form';

export const useModalForm = (modalProps: TModalForm, onBackToForm: VoidFunction): JSX.Element => {
  const status = useSelector(selectFormStatus);

  switch (status) {
    case EStatus.Loading:
      return <Loading />;
    case EStatus.Succeed:
      return <Success />;
    case EStatus.Failed:
      return <Failed onBackToForm={onBackToForm} />;
    default:
      return <ModalForm {...modalProps} />;
  }
};
